import { ChatboxStore } from "../../store";
import type { ChatboxCallbacks, ChatboxProps } from "../../types";
import { useListenEvents } from "../useListenEvents";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { useCreation, useDeepCompareEffect } from "ahooks";

export const useChatbox = (props: ChatboxProps) => {
  const { callbacks, ...restProps } = props;

  const callbackRefs: ChatboxCallbacks = {
    onSendMessageSuccess: useCallbackRef(callbacks?.onSendMessageSuccess),
    onMessageReceived: useCallbackRef(callbacks?.onMessageReceived),
  };
  const options = {
    ...restProps,
    callbacks: callbackRefs,
  };

  const store = useCreation(() => new ChatboxStore(options), []);

  const {
    bind: { setOptions },
  } = store;

  useListenEvents(store);

  useDeepCompareEffect(() => {
    setOptions(options);
  }, [restProps, callbackRefs]);

  return {
    store,
  };
};
